import { NavLink, Outlet, useOutletContext } from 'react-router-dom';

const CRM_TABS: { to: string; label: string; icon: string }[] = [
  { to: 'filas', label: 'Inteligência / Filas', icon: 'ri-list-check-3' },
  { to: 'leads', label: 'Leads', icon: 'ri-building-4-line' },
  { to: 'pipeline', label: 'Pipeline', icon: 'ri-filter-3-line' },
  { to: 'whatsapp', label: 'WhatsApp', icon: 'ri-whatsapp-line' },
  { to: 'calendario', label: 'Calendário', icon: 'ri-calendar-line' },
  { to: 'funil', label: 'Funil', icon: 'ri-bar-chart-2-line' },
  { to: 'ia', label: 'IA comercial', icon: 'ri-sparkling-2-line' },
];

export default function CrmModule() {
  const { password } = useOutletContext<{ password: string }>();

  return (
    <div className="space-y-5">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 flex items-center justify-center bg-[#E8610A]/10 text-[#E8610A] rounded-xl">
          <i className="ri-customer-service-2-line text-lg"></i>
        </div>
        <div>
          <h2 className="font-bold text-gray-900">CRM</h2>
          <p className="text-sm text-gray-500">
            Leads, pipeline, WhatsApp, calendário, funil e IA comercial
          </p>
        </div>
      </div>

      {/* Sub-navegação do CRM (rotas reais) */}
      <div className="bg-white rounded-2xl border border-gray-200 px-2 py-2 flex items-center gap-1 overflow-x-auto">
        {CRM_TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            className={({ isActive }) =>
              `inline-flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-semibold whitespace-nowrap transition-colors duration-150 cursor-pointer ${
                isActive
                  ? 'bg-[#E8610A] text-white'
                  : 'text-gray-600 hover:bg-gray-100'
              }`
            }
          >
            <i className={t.icon}></i>
            {t.label}
          </NavLink>
        ))}
      </div>

      <Outlet context={{ password }} />
    </div>
  );
}